import React from "react";
import { SearchbarCom, UserRollCom, SidenavbarCom } from "../../components";
import Functions from "./index.functoin";
export default function Favourites() {
  const { filteredFavourites } = Functions();
  return (
    <div className="h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 scroll-container h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 pt-2 pb-1 h-full`}>
            <div className="flex flex-col relative w-full bg-[#1A1A1A] xs:px-2 h-full sm:px-3 lg:px-5 rounded-lg">
              <div className="py-5 sm:py-10">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-4xl font-onestSemiBold">
                  Favourites
                </h1>
              </div>
              <div className=" w-full">
                <div className="grid xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-2  xl:grid-cols-3 xs:gap-y-4 sm:gap-y-5 sm:gap-x-5 lg:gap-x-6">
                  {filteredFavourites?.map((value, index) => (
                    <div key={index}>
                      <UserRollCom
                        icon={value?.icon}
                        title={value?.title}
                        bgColor={"#1F1F1F"}
                        iconsClass={
                          "xs:w-[40px] xs:h-[40px] sm:w-[50px] sm:h-[50px] lg:w-[80px] lg:h-[80px]"
                        }
                        to={value?.to}
                        themeclass={
                          " xs:rounded-2xl sm:rounded-3xl xs:py-6 sm:py-7 lg:py-10 flex justify-center items-center flex-col cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-md"
                        }
                        textclass={
                          "text-white xs:pt-[5px] sm:pt-1 lg:pt-1.5 text-center capitalize font-onestRegular xs:text-sm lg:text-xl"
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
